export const prefix = 'organizations/';
export const IDToName = ({ organizationID }) => {
    return prefix + organizationID;
};
export const nameToID = (name) => {
    const parts = name.split('/');
    if (parts.length !== 2) {
        throw new Error(`wrong number of parts in ${name}`);
    }
    return {
        organizationID: parts[1],
    };
};
